/**
 * @flow
 * @relayHash 3cb99a2036d62b66c7426fd8f6a2dac0
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type NpsByHourOfDayWidgetQueryResponse = {|
  +widget: ?{|
    +id: string;
    +name: ?string;
    +config: ?{|
      +subtitle: ?string;
      +hideHeader: ?boolean;
      +question: ?{|
        +text: ?$ReadOnlyArray<?{|
          +language: ?string;
          +text: ?string;
        |}>;
        +answersReport: ?{|
          +count: ?number;
        |};
      |};
    |};
  |};
|};
*/


/*
query NpsByHourOfDayWidgetQuery(
  $widgetId: ID!
  $from: String!
  $to: String!
  $deviceIds: [ID]!
  $filterComments: Boolean!
  $demoData: Boolean!
  $questionFilters: [QuestionFilterInput]
  $aggregateQuestions: [ID]
) {
  widget(id: $widgetId) {
    id
    name
    config {
      subtitle
      hideHeader
      question {
        text {
          language
          text
        }
        answersReport(from: $from, to: $to, deviceIds: $deviceIds, filterComments: $filterComments, demoData: $demoData, questionFilters: $questionFilters, aggregateQuestions: $aggregateQuestions) {
          count
          ...NpsByHourOfDayBarChart_answersReport
        }
        id
      }
    }
  }
}

fragment NpsByHourOfDayBarChart_answersReport on AnswersReport {
  npsByHourOfDay {
    hour
    nps
    count
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "widgetId",
        "type": "ID!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "from",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "to",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "deviceIds",
        "type": "[ID]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "filterComments",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "demoData",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "questionFilters",
        "type": "[QuestionFilterInput]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aggregateQuestions",
        "type": "[ID]",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NpsByHourOfDayWidgetQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "widgetId",
            "type": "ID"
          }
        ],
        "concreteType": "Widget",
        "name": "widget",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "WidgetConfig",
            "name": "config",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "subtitle",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "hideHeader",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "name": "question",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Translation",
                    "name": "text",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "language",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "aggregateQuestions",
                        "variableName": "aggregateQuestions",
                        "type": "[ID]"
                      },
                      {
                        "kind": "Variable",
                        "name": "demoData",
                        "variableName": "demoData",
                        "type": "Boolean"
                      },
                      {
                        "kind": "Variable",
                        "name": "deviceIds",
                        "variableName": "deviceIds",
                        "type": "[ID]"
                      },
                      {
                        "kind": "Variable",
                        "name": "filterComments",
                        "variableName": "filterComments",
                        "type": "Boolean"
                      },
                      {
                        "kind": "Variable",
                        "name": "from",
                        "variableName": "from",
                        "type": "String"
                      },
                      {
                        "kind": "Variable",
                        "name": "questionFilters",
                        "variableName": "questionFilters",
                        "type": "[QuestionFilterInput]"
                      },
                      {
                        "kind": "Variable",
                        "name": "to",
                        "variableName": "to",
                        "type": "String"
                      }
                    ],
                    "concreteType": "AnswersReport",
                    "name": "answersReport",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "NpsByHourOfDayBarChart_answersReport",
                        "args": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "NpsByHourOfDayWidgetQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "widgetId",
        "type": "ID!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "from",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "to",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "deviceIds",
        "type": "[ID]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "filterComments",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "demoData",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "questionFilters",
        "type": "[QuestionFilterInput]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aggregateQuestions",
        "type": "[ID]",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "NpsByHourOfDayWidgetQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "widgetId",
            "type": "ID"
          }
        ],
        "concreteType": "Widget",
        "name": "widget",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "WidgetConfig",
            "name": "config",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "subtitle",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "hideHeader",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "name": "question",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Translation",
                    "name": "text",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "language",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "aggregateQuestions",
                        "variableName": "aggregateQuestions",
                        "type": "[ID]"
                      },
                      {
                        "kind": "Variable",
                        "name": "demoData",
                        "variableName": "demoData",
                        "type": "Boolean"
                      },
                      {
                        "kind": "Variable",
                        "name": "deviceIds",
                        "variableName": "deviceIds",
                        "type": "[ID]"
                      },
                      {
                        "kind": "Variable",
                        "name": "filterComments",
                        "variableName": "filterComments",
                        "type": "Boolean"
                      },
                      {
                        "kind": "Variable",
                        "name": "from",
                        "variableName": "from",
                        "type": "String"
                      },
                      {
                        "kind": "Variable",
                        "name": "questionFilters",
                        "variableName": "questionFilters",
                        "type": "[QuestionFilterInput]"
                      },
                      {
                        "kind": "Variable",
                        "name": "to",
                        "variableName": "to",
                        "type": "String"
                      }
                    ],
                    "concreteType": "AnswersReport",
                    "name": "answersReport",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "NpsByHourOfDay",
                        "name": "npsByHourOfDay",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "hour",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "nps",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "count",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query NpsByHourOfDayWidgetQuery(\n  $widgetId: ID!\n  $from: String!\n  $to: String!\n  $deviceIds: [ID]!\n  $filterComments: Boolean!\n  $demoData: Boolean!\n  $questionFilters: [QuestionFilterInput]\n  $aggregateQuestions: [ID]\n) {\n  widget(id: $widgetId) {\n    id\n    name\n    config {\n      subtitle\n      hideHeader\n      question {\n        text {\n          language\n          text\n        }\n        answersReport(from: $from, to: $to, deviceIds: $deviceIds, filterComments: $filterComments, demoData: $demoData, questionFilters: $questionFilters, aggregateQuestions: $aggregateQuestions) {\n          count\n          ...NpsByHourOfDayBarChart_answersReport\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment NpsByHourOfDayBarChart_answersReport on AnswersReport {\n  npsByHourOfDay {\n    hour\n    nps\n    count\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByHourOfDayWidget/__generated__/NpsByHourOfDayWidgetQuery.graphql.js